/**
 * @module files/SourceType
 */

export const sourceType = {
    dropbox: 1,
    google: 2,
    oneDriveForBusiness: 3,
    local: 4,
    oneDrivePersonal: 5,
    webDav: 6,
    ziggeo: 7,
};
